export const CONTENT_URL = "/ghostbeats-content.json";
